module.exports = __webpack_public_path__ + "img/mobapp.cae60964.svg";